__turbopack_context__.v({
  "cats": "style-module-scss-module__yr7d5a__cats",
  "main": "style-module-scss-module__yr7d5a__main",
});
